import React, { useEffect, useRef, useState } from 'react';
import styles from '../PostView.module.scss';
import { ContentParser } from '../../ContentEditor/Parser';
import { AppAvatar } from '../../Avatar';
import { VideoPlayerComponent } from '../../../core/VideoPlayer';
import { ImageSlider } from '../../../core/CustomImageSlider';
import ReactAudioPlayer from 'react-audio-player';
import EmojiPostPicker from '../EmojiPicker/EmojiPostPicker';
import EmojiDisplay from '../EmojiPicker/EmojiDisplay';
import PostActions from '../Components/PostActions';
import UserPostCard from '../../UserPostCard';
import { Button, Dropdown, Select, openNotification, ANTD_COMPONENTS } from 'tt-ui-lib/core';
import {
  FileIcon,
  LeftIcon,
  LikeIcon,
  MoreVIcon,
  ShareTTIcon,
  CommentsIcon,
  CopyIcon,
  DownloadIcon,
} from 'tt-ui-lib/icons';
import moment from 'moment';
import ArticleBodyLayout from './ArticleBodyLayout';
import { useNavigate } from 'react-router';
import { downloadFileFromURL } from '../../../utils/appUtils';
import ReactionsModal from '../Components/ReactionsModal';
import LinkPreview from '../../Modals/NewPostModal/Components/Previews/LinkPreview';
import { clip } from '../../../utils/stringUtils';

const { Avatar } = ANTD_COMPONENTS;

const AuthPostView = ({
  postInstance,
  postBody,
  user,
  selectedReaction,
  likeLoading,
  allowedReactions,
  selectReaction,
  clearReaction,
  openPost,
  openComments,
  sharePost,
  selectedActionUser,
  setSelectedActionUser,
  isPostPage = false,
  isArticle = false,
  focusComment,
  onDeletePost,
  openUserProfile,
  isContent = false,
  reactions,
  emojiCount,
}) => {
  const navigate = useNavigate();
  const feedBodyRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [isTextMaxLength, setIsTextMaxLength] = useState(false);
  const [isTextShowFull, setIsTextShowFull] = useState(false);
  const [shortFeedText, setShortFeedText] = useState(postBody);
  const linkPreview = postInstance?.link_preview ? JSON.parse(postInstance.link_preview) : null;

  const [openReactionsModal, setOpenReactionsModal] = useState(false);

  const copyFileLink = (url) => {
    navigator.clipboard.writeText(url).then(() => {
      openNotification({
        type: 'success',
        message: 'Link copied in clipboard',
      });
      setOpen(false);
    });
  };

  useEffect(() => {
    setIsTextMaxLength(false);
    const shortedBody = clip(postBody, 480, {
      html: true,
      stripTags: true,
      breakWords: true,
      onMaxCount: () => {
        setIsTextMaxLength(true);
      },
    });

    setShortFeedText(shortedBody || postBody);
  }, [postBody]);

  return (
    <>
      {isPostPage ? (
        <div className={styles.postHeader}>
          <div
            className={styles.articleHeadButton}
            onClick={() => navigate(isContent ? '/dashboard/content' : '/dashboard/feed')}
          >
            <LeftIcon style={{ width: 20, height: 20 }} />
            <span>Back</span>
          </div>

          <Dropdown
            open={open}
            onOpenChange={(value) => setOpen(value)}
            // eslint-disable-next-line react/no-unstable-nested-components
            dropdownRender={() => (
              <div
                onClick={() => setOpen(false)}
                style={{
                  padding: 10,
                  borderRadius: 12,
                  background: '#ffffff',
                  boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
                }}
              >
                <PostActions
                  user={user}
                  postInstance={postInstance}
                  isArticle={isArticle}
                  onDeletePost={onDeletePost}
                  closeMenu={() => setOpen(false)}
                />
              </div>
            )}
            trigger="click"
          >
            <Button type="icon">
              <MoreVIcon style={{ width: 20, height: 20, flexShrink: 0, fontSize: 20 }} />
            </Button>
          </Dropdown>
        </div>
      ) : (
        <div className={styles.postHeader}>
          <div className={styles.postAvatar} onClick={openUserProfile}>
            <AppAvatar
              nav={1}
              size="xs"
              userName={
                postInstance?.user
                  ? `${postInstance.user.first_name} ${postInstance.user.last_name}`
                  : 'Unknown'
              }
              src={postInstance?.user?.avatarSmall || ''}
            />
            <div className={styles.postAvatarTitle}>
              <p>
                {postInstance?.user
                  ? `${postInstance.user.first_name} ${postInstance.user.last_name}`
                  : 'Unknown'}
              </p>
              <span>{moment(postInstance.updated_at).format('DD/MM/YYYY')}</span>
            </div>
          </div>

          <Dropdown
            open={open}
            onOpenChange={(value) => setOpen(value)}
            // eslint-disable-next-line react/no-unstable-nested-components
            dropdownRender={() => (
              <div
                onClick={() => setOpen(false)}
                style={{
                  padding: 10,
                  borderRadius: 12,
                  background: '#ffffff',
                  boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
                }}
              >
                <PostActions
                  user={user}
                  postInstance={postInstance}
                  isArticle={isArticle}
                  onDeletePost={onDeletePost}
                  closeMenu={() => setOpen(false)}
                />
              </div>
            )}
            trigger="click"
          >
            <Button type="icon" className={styles.postMenuButton}>
              <MoreVIcon style={{ width: 20, height: 20, flexShrink: 0, fontSize: 20 }} />
            </Button>
          </Dropdown>
        </div>
      )}

      {isPostPage && !isArticle && (
        <div className={styles.pageUserRow}>
          <div className={styles.postAvatar} onClick={openUserProfile}>
            <AppAvatar
              nav={1}
              size="xs"
              userName={
                postInstance?.user
                  ? `${postInstance.user.first_name} ${postInstance.user.last_name}`
                  : 'Unknown'
              }
              src={postInstance?.user?.avatarSmall || ''}
            />
            <div className={styles.postAvatarTitle}>
              <p>
                {postInstance?.user
                  ? `${postInstance.user.first_name} ${postInstance.user.last_name}`
                  : 'Unknown'}
              </p>
              <span>{moment(postInstance.updated_at).format('DD/MM/YYYY')}</span>
            </div>
          </div>
        </div>
      )}

      {isArticle ? (
        <ArticleBodyLayout
          postInstance={postInstance}
          postBody={postBody}
          openPost={openPost}
          isPostPage={isPostPage}
          openUserProfile={openUserProfile}
        />
      ) : (
        <div
          onClick={() => {
            if (!isPostPage) {
              openPost();
            }
          }}
          style={{
            cursor: !isPostPage ? 'pointer' : 'default',
          }}
        >
          {isPostPage ? (
            <div className={styles.postBody}>
              <ContentParser content={postBody} />
            </div>
          ) : (
            <div ref={feedBodyRef} className={`${styles.postBodyFeed}`}>
              <ContentParser content={!isTextShowFull ? shortFeedText : postBody} />
              {isTextMaxLength && (
                <div
                  className={styles.postBodyFeedCroped}
                  onClick={(event) => {
                    event.stopPropagation();

                    if (isTextShowFull) {
                      setIsTextShowFull(false);
                    } else {
                      setIsTextShowFull(true);
                    }
                  }}
                >
                  {isTextShowFull ? 'Hide' : 'Show more'}
                </div>
              )}
            </div>
          )}

          {linkPreview && (
            <LinkPreview
              url={linkPreview.url}
              title={linkPreview.title}
              description={linkPreview.description}
              imageUrl={linkPreview.image}
            />
          )}
        </div>
      )}

      {postInstance.type === 'cart' ? (
        <div className={styles.fileBox}>
          <UserPostCard type="expert" name="Brandon Wood" />
        </div>
      ) : (
        <>
          {postInstance.files_image.length > 0 &&
            postInstance.files_video.length === 0 &&
            ((isArticle && isPostPage) || !isArticle) && (
              <div className={styles.fileBox}>
                <div
                  className={`${styles.fileBox} ${styles.imagesWrapper}`}
                  onClick={(event) => event.stopPropagation()}
                >
                  <ImageSlider array={postInstance.files_image} />
                </div>
              </div>
            )}
          {postInstance.files_video.length >= 1 && ((isArticle && isPostPage) || !isArticle) && (
            <div className={styles.fileBox}>
              <VideoPlayerComponent
                src={postInstance.files_video[0].path}
                className={styles.videoBox}
              />
            </div>
          )}

          {postInstance.files_audio.length >= 1 && ((isArticle && isPostPage) || !isArticle) && (
            <div className={styles.filesWrapper}>
              {postInstance.files_audio.map((e) => (
                <div className={styles.audioPlayerDiv} onClick={(event) => event.stopPropagation()}>
                  <span className={styles.audioPlayerName}>{e.original_name}</span>
                  <ReactAudioPlayer src={e.path} className={styles.audioPlayer} controls />
                </div>
              ))}
            </div>
          )}
          {postInstance.files_doc.length >= 1 && ((isArticle && isPostPage) || !isArticle) && (
            <div className={styles.filesWrapper}>
              {postInstance.files_doc.map((e) => (
                <div
                  className={styles.docsFileWrapper}
                  onClick={(event) => event.stopPropagation()}
                >
                  <div className={styles.docTitle}>
                    <FileIcon style={{ width: 20, height: 20, flexShrink: 0 }} />
                    <span>{e.original_name}</span>
                  </div>
                  <div>
                    <Button type="icon" onClick={() => copyFileLink(e.path)}>
                      <CopyIcon style={{ width: 18, height: 18, marginRight: 10 }} />
                    </Button>
                    <Button
                      type="icon"
                      onClick={() => downloadFileFromURL(e.path, e.original_name)}
                    >
                      <DownloadIcon style={{ width: 18, height: 18, marginRight: 10 }} />
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      <div className={styles.postStatistics}>
        <div
          className={styles.postStatisticsReacts}
          onClick={() => {
            setOpenReactionsModal(true);
          }}
        >
          <div>
            <EmojiDisplay
              allowedReactions={allowedReactions}
              emojiList={(reactions && reactions.map((item) => item.emoji_id)) || []}
            />
            <p>{emojiCount || ''}</p>
          </div>
        </div>
        <div>
          {postInstance.is_available_comments === 1 && (
            <span>Comments: {postInstance.comments_count || 0}</span>
          )}
          <span>Shares: {postInstance.shares_count || 0}</span>
        </div>
      </div>

      <div className={styles.postFooter}>
        <EmojiPostPicker
          selectedEmoji={selectedReaction}
          allowedEmoji={allowedReactions}
          selectReaction={selectReaction}
          clearReaction={clearReaction}
          likeLoading={likeLoading}
          placeholder={
            <div className={styles.postFooterButtons}>
              <div>
                <LikeIcon style={{ width: 24, height: 24 }} />
              </div>
              <span>Like</span>
            </div>
          }
        />
        {postInstance.is_available_comments === 1 && (
          <div
            className={styles.postFooterButtons}
            onClick={isPostPage ? focusComment : openComments}
          >
            <div>
              <CommentsIcon style={{ width: 24, height: 24 }} />
            </div>
            <span>Comment</span>
          </div>
        )}
        <div className={styles.postFooterButtons} onClick={sharePost}>
          <div>
            <ShareTTIcon style={{ width: 24, height: 24 }} />
          </div>
          <span>Share</span>
        </div>

        <div className={styles.postFooterButtons}>
          <div className={styles.inputOptions}>
            <Select
              className={styles.select}
              value={selectedActionUser}
              label="Select user"
              onChange={(value) => setSelectedActionUser(value)}
              optionLabelProp="avatar"
              options={[
                {
                  value: user?.id || '',
                  avatar: (
                    <Avatar src={user?.avatar} className={styles.avatar}>
                      {user?.first_name
                        ? `${user.first_name} ${user.last_name}`
                            .split(' ')
                            .map((i) => i[0])
                            .join('')
                        : ''}
                    </Avatar>
                  ),
                  label: (
                    <div className={styles.selectItem}>
                      <Avatar src={user?.avatar} className={styles.avatar}>
                        {user?.first_name
                          ? `${user.first_name} ${user.last_name}`
                              .split(' ')
                              .map((i) => i[0])
                              .join('')
                          : ''}
                      </Avatar>
                      <span>
                        {user.first_name} {user.last_name}
                      </span>
                    </div>
                  ),
                },
              ]}
            />
          </div>
        </div>
      </div>

      <ReactionsModal
        isOpen={openReactionsModal}
        setIsOpen={setOpenReactionsModal}
        id={postInstance.id}
        isPost
      />
    </>
  );
};

export default AuthPostView;
